import React from "react";
import { StatCard } from "@/components/ui";
import { Maximize2, Minimize2, CheckCircle2, FileText, Wallet, IndianRupee, AlertCircle } from "lucide-react";

const fmt = (v) => new Intl.NumberFormat("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(v);

export const ProjectGeneralStats = ({ stats = {}, isExpanded, onToggle }) => {
  const {
    count,
    requestedTotal,
    approvedAmount,
    otherExpensesTotal,
    projectExpensesTotal,
    pendingPaymentsCount
  } = stats;

  return (
    <div className="space-y-4 relative group/stats">
      {/* Developer : Nithin
      Date : 26-06-2026
      changes: commented out the Show/Hide Charts toggle button as per user request */}
      {/* <button
        onClick={onToggle}
        className="absolute -top-2 right-0 z-10 p-2 bg-white border border-slate-200 rounded-xl shadow-sm text-slate-400 hover:text-brand-blue hover:border-brand-blue/30 transition-all hover:bg-slate-50 active:scale-95"
        title={isExpanded ? "Hide Charts" : "Show Charts"}
      >
        {isExpanded ? <Minimize2 size={10} /> : <Maximize2 size={10} />}
      </button> */}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 auto-rows-fr">
        <StatCard
          variant="luxury"
          title="Total Requests"
          value={count || 0}
          sub="Total expenses tracked"
          isExpanded={isExpanded}
          topColor="border-t-[#5d6b8b]"
          iconHoverColor="group-hover:text-[#ffa000]"
          illustration={<FileText className="w-10 h-10" strokeWidth={2} />}
        />

        <StatCard
          variant="luxury"
          title="Total Requested Amount"
          value={`₹${fmt(requestedTotal || 0)}`}
          sub="Overall requested amount"
          isExpanded={isExpanded}
          topColor="border-t-[#5d6b8b]"
          iconHoverColor="group-hover:text-[#ffa000]"
          illustration={<IndianRupee className="w-10 h-10" strokeWidth={2} />}
        />

        <StatCard
          variant="luxury"
          title="Total Approved Amount"
          value={`₹${fmt(approvedAmount || 0)}`}
          sub="Overall approved amount"
          isExpanded={isExpanded}
          topColor="border-t-[#5d6b8b]"
          iconHoverColor="group-hover:text-[#ffa000]"
          illustration={<CheckCircle2 className="w-10 h-10" strokeWidth={2} />}
        />

        {stats.category === 'general' ? (
          <div className="animate-pulse shadow-[0_0_15px_rgba(225,29,72,0.4)] rounded-2xl">
            <StatCard
              variant="luxury"
              title={<span className="text-rose-500 font-bold">Pending Payments</span>}
              value={<span className="text-rose-600">{pendingPaymentsCount || 0}</span>}
              sub={<span className="text-rose-400 font-medium">Action Required</span>}
              isExpanded={isExpanded}
              topColor="border-t-rose-500"
              iconHoverColor="group-hover:text-rose-600"
              illustration={<AlertCircle className="w-10 h-10 text-rose-500" strokeWidth={2} />}
            />
          </div>
        ) : (
          <StatCard
            variant="luxury"
            title={stats.category === 'project' ? "Total Project Expenses" : "General / Project Expenses"}
            value={
              stats.category === 'project' ? `₹${fmt(projectExpensesTotal || 0)}` :
              <div className="flex items-baseline gap-1">
                <span title="General Expenses">₹{fmt(otherExpensesTotal || 0)}</span>
                <span className="text-slate-300 font-medium text-sm">/</span>
                <span title="Project Expenses" className="text-slate-500 text-base">₹{fmt(projectExpensesTotal || 0)}</span>
              </div>
            }
            sub={stats.category === 'project' ? "Overall project expenses" : "General vs Project Expenses"}
            isExpanded={isExpanded}
            topColor="border-t-[#5d6b8b]"
            iconHoverColor="group-hover:text-[#ffa000]"
            illustration={<Wallet className="w-10 h-10" strokeWidth={2} />}
          />
        )}
      </div>
    </div>
  );
};
